import React from 'react';
import NextButton from "../button/NextButton";
import BackButton from "../button/BackButton";
import { PdsSidebar } from "@principal/design-system-react";
import Button from "../button/Button";
import { ButtonClass } from "../enums/ButtonClass";
import SaveIncompleteIntakeModal from "../structure/SaveIncompleteIntakeModal";
import { PdsIconDownload } from "@principal/design-system-icons-react";

export type BackNextProps = {
    showSave?: boolean,
    back?: (e: Event) => void,
    next?: (e: Event) => void,
    children?: React.ReactNode,
}

const BackNext = (props: BackNextProps) => {
    const [showIncompleteIntakeModal, setShowIncompleteIntakeModal] = React.useState(false);

    return (
        <PdsSidebar gap="none">
            <div className="pds-u-padding-right-16 pds-u-padding-top-12">
                {props.showSave && <div className="pds-u-float-left">
                    <Button mainButtonClass={ButtonClass.DEFAULT}
                            buttonContent={<><PdsIconDownload slot="icon-left"/>&nbsp;<span>Save progress</span></>}
                            onClick={() => {
                                setShowIncompleteIntakeModal(true);
                            }}/>
                    {showIncompleteIntakeModal && <SaveIncompleteIntakeModal onModalClose={() => {
                        setShowIncompleteIntakeModal(false);
                    }}/>}
                </div>}
                <div className="pds-u-float-right pds-u-flex" style={{gap: "16px"}}>
                    {props.back ? <BackButton onClick={props.back}/> : null}
                    {props.next ? <NextButton onClick={props.next}/> : null}
                </div>
            </div>
            <div slot="right-sidebar" className="pds-u-padding-horizontal-16"/>
        </PdsSidebar>
    )
};
export default BackNext;